import * as Types from '../../../../gql/__generated/graphql.types';

import { CollectionFieldsFragment, CollapsibleSectionFieldsFragment } from './collection.generated';
import { CollectionFieldsFragmentDoc, CollapsibleSectionFieldsFragmentDoc } from './collection.generated';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { graphqlFetcher } from '@/modules/common/services/graphqlFetcher';
export type CollectionCollectionsQueryVariables = Types.Exact<{
  slug_in?: Types.InputMaybe<Array<Types.InputMaybe<Types.Scalars['String']['input']>> | Types.InputMaybe<Types.Scalars['String']['input']>>;
}>;


export type CollectionCollectionsQuery = (
  { __typename?: 'Query' }
  & { collectionCollection?: Types.Maybe<(
    { __typename?: 'CollectionCollection' }
    & CollectionFieldsFragment
  )> }
);



export const CollectionCollectionsDocument = `
    query collectionCollections($slug_in: [String]) {
  collectionCollection(where: {slug_in: $slug_in}) {
    ...CollectionFields
  }
}
    ${CollectionFieldsFragmentDoc}
${CollapsibleSectionFieldsFragmentDoc}`;

export const useCollectionCollectionsQuery = <
      TData = CollectionCollectionsQuery,
      TError = unknown
    >(
      variables?: CollectionCollectionsQueryVariables,
      options?: Omit<UseQueryOptions<CollectionCollectionsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CollectionCollectionsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CollectionCollectionsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['collectionCollections'] : ['collectionCollections', variables],
    queryFn: graphqlFetcher<CollectionCollectionsQuery, CollectionCollectionsQueryVariables>(CollectionCollectionsDocument, variables),
    ...options
  }
    )};

useCollectionCollectionsQuery.getKey = (variables?: CollectionCollectionsQueryVariables) => variables === undefined ? ['collectionCollections'] : ['collectionCollections', variables];


useCollectionCollectionsQuery.fetcher = (variables?: CollectionCollectionsQueryVariables, options?: RequestInit['headers']) => graphqlFetcher<CollectionCollectionsQuery, CollectionCollectionsQueryVariables>(CollectionCollectionsDocument, variables, options);
